<template>
  <div
    class="relative flex h-full w-12 flex-col bg-lexmea-gray-500 px-1 transition-all sm:px-2"
    :class="{
      'sm:w-14 lg:w-16': collapsed,
      'sm:w-[11.5rem] xl:w-[13.5rem]': !collapsed && !showcase,
      'sm:w-56 lg:w-64': !collapsed && showcase,
    }"
  >
    <button
      class="absolute bottom-0 top-0 w-2 cursor-pointer px-2 opacity-100 transition-opacity max-sm:hidden"
      :class="end ? '-left-2' : '-right-2'"
      :title="collapsed ? t('expand_column') : t('collapse_column')"
      @click="collapsed = !collapsed"
    >
      <span
        class="absolute top-1/2 grid h-6 w-3 -translate-x-[6px] -translate-y-1/2 place-items-center rounded-sm bg-lexmea-gray-900"
      >
        <template v-if="end">
          <i-heroicons-chevron-left-20-solid
            v-if="collapsed"
            class="h-3 w-3"
            aria-hidden="true"
          />
          <i-heroicons-chevron-right-20-solid
            v-else
            class="h-3 w-3"
            aria-hidden="true"
          />
        </template>
        <template v-else>
          <i-heroicons-chevron-right-20-solid
            v-if="collapsed"
            aria-hidden="true"
            class="h-3 w-3"
          />
          <i-heroicons-chevron-left-20-solid
            v-else
            aria-hidden="true"
            class="h-3 w-3"
          />
        </template>
      </span>
    </button>
    <div
      class="grid h-full min-h-0 w-full grid-flow-row auto-rows-auto grid-cols-1 gap-3"
      :class="[spaceBetween ? 'content-between' : 'content-start']"
    >
      <slot :collapsed="collapsed" />
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  end?: boolean;
  spaceBetween?: boolean;
}

defineProps<Props>();

const { t } = useI18n({ useScope: "local" });

const { isSmallerThanSm } = useLexMeaTailwindBreakpoints();

const collapsed = ref(isSmallerThanSm.value);

// makes column 1 collapsed on smaller screens
watch(isSmallerThanSm, (v) => (collapsed.value = v));

const showcase = useExamShowcase();
</script>

<i18n>
{
  "de": {
    "collapse_column": "Spalte @:ui.collapse",
    "expand_column": "Spalte @:ui.expand"
  },
  "en": {
    "collapse_column": "@:ui.collapse column",
    "expand_column": "@:ui.expand column"
  }
}
</i18n>
